import React, { StatelessComponent} from 'react';
import cls from '../utils/classnames';
import { BUTTON, BUTTON_BLOCK } from '../utils/classes';
import './_styles.scss';

export type ButtonType = 'submit' | 'reset' | 'button';
export type ButtonVariant = 'info' | 'primary' | 'dark' | 'purple' | 'default';

/**
 * Button props.
 */
export interface IButtonProps {
    /**
     * The type property.
     * see https://www.w3.org/TR/2011/WD-html5-20110525/the-button-element.html#attr-button-type for more info.
     */
    type: ButtonType;
    /**
     * The button text.
     */
    children: React.ReactNode;
    /**
     * Type of button.,
     */
    variant?: ButtonVariant;
    /**
     * Makes the button occupy all available space in the container.
     */
    block?: boolean;
    /**
     * The elements id.
     */
    id?: string;
    /**
     * Additional class names to add-
     */
    className?: string;
    /**
     * disabled component property
     */
    disabled?: boolean;
    /**
     * callback to execute
     */
    onClick?: () => void;
    /**
     * callback to execute
     */
    onBlur?: () => void;
    /**
     * callback to execute
     */
    onFocus?: () => void;
    /**
     * react css property object
     */
    style?: React.CSSProperties
    /**
     * activate scale transition
     */
    activate?: boolean;
    /**
     * show only in register
     */
    img?: string;
    dataOptions ?: object;
    //* Disabled transition focus left or right
    blockedLeft?: object;
    blockedRight?: object;
}

/**
 * A button component.
 */
export const Button: StatelessComponent<IButtonProps> = ({
    id,
    block,
    type,
    disabled = false,
    children,
    variant,
    className,
    onClick,
    onBlur,
    onFocus,
    style,
    activate,
    img,
    dataOptions = {},
    blockedLeft = {},
    blockedRight = {}
}) => {
    const classes = cls(
        BUTTON,
        `${BUTTON}-${variant}`,
        {
            [BUTTON_BLOCK]: block as boolean,
        },
        className,
        disabled ? 'disabled' : '',
        activate ? 'button-container': ''
    );

  return (
    // La version legacy de Samsung no soporta onclick en el elemento button
    // se hace un fix cambiando el elemento
    <a
      id={id}
      className={classes}
      href="javascript:void(0)"
      tabIndex={0}
      onClick={onClick}
      onBlur={onBlur}
      onFocus={onFocus}
      style={style}
      {...dataOptions}
      {...blockedLeft}
      {...blockedRight}
    >
      {img !== undefined ? (<img className={cls(`${BUTTON}-img`)} src={img} alt={img} /> ) : ''}
      {children}
    </a>
  );
};

Button.defaultProps = {
    block: false,
    variant: 'default'
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Button/index.tsx